module.exports = __webpack_public_path__ + "img/logo_m.fb3ca792.png";